import gql from 'graphql-tag'

export const SECTION_PEEK_PRODUCT_LIST_QUERY = gql`
  query SectionPeekProducts(
    $path: PagePath!
    $id: ID!
    $input: ProductListInput!
    $currency: Currency!
    $shippingDestination: Country!
    $clickAndCollectEnabled: Boolean = false
    $vipPriceEnabled: Boolean! = false
  ) {
    sectionPeekProducts(
      path: $path
      id: $id
      input: $input
      currency: $currency
      shippingDestination: $shippingDestination
      clickAndCollectEnabled: $clickAndCollectEnabled
      vipPriceEnabled: $vipPriceEnabled
    ) @client {
      externalIdentifier
      sku
      url
      title
      inStock
      imageUrl
      brand {
        name
        imageUrl
      }
      reviews {
        total
        averageScore
      }
      price {
        defaultPrice
        minPrice
        maxPrice
      }
      rrp {
        defaultPrice
        minPrice
        maxPrice
      }
      content {
        key
        value {
          ... on ProductContentStringValue {
            stringValue: value
          }
          ... on ProductContentStringListValue {
            stringListValue: value
          }
        }
      }
      colourSwatches
      isCheckStock @include(if: $clickAndCollectEnabled)
      isOrderInStore @include(if: $clickAndCollectEnabled)
      icons @include(if: $clickAndCollectEnabled)
      leadTime @include(if: $clickAndCollectEnabled)
      weightGroups @include(if: $clickAndCollectEnabled)
      inStockLocations @include(if: $clickAndCollectEnabled)
      isBookable @include(if: $clickAndCollectEnabled)
      marketedSpecialOffer {
        title {
          content {
            content
          }
        }
        description {
          content {
            content
          }
        }
        landingPageLink {
          text
          url
          openExternally
          noFollow
        }
      }
    }
  }
`

export const QUBIT_PRODUCT_LIST_QUERY = gql`
  query SectionPeekProducts(
    $skus: [SKU!]!
    $currency: Currency!
    $shippingDestination: Country!
  ) {
    qubitSectionPeekProducts(
      skus: $skus
      currency: $currency
      shippingDestination: $shippingDestination
    ) @client {
      sku
      url
      title
      imageUrl
      inStock
      reviews {
        total
        averageScore
      }
      price {
        defaultPrice
        minPrice
        maxPrice
      }
      rrp {
        defaultPrice
        minPrice
        maxPrice
      }
    }
  }
`
